import { ArrowBackIos } from "@material-ui/icons";
import React, { FC, useState, useEffect } from "react";
import ItemCard from "../ItemCard/ItemCard";
import styles from "./RegisterCustomer.module.scss";
import { cus_data } from "./data";

interface IProps {
  onClick: any;
  customerList: any;
}

const RegisterCustomer: FC<IProps> = ({ onClick, customerList }) => {
  const [toggleRegister, settoggleRegister] = useState<any>({
    isToggled: false,
    customer: null,
  });
  const [data, setData] = useState<any>(cus_data);
  console.table(data);
  const [filterQuery, setfilterQuery] = useState<String>("");
  const [customer, setcustomer] = useState<any>({
    customer_code: 1234,
    customer_name: "",
    contact_no: "",
    email: "",
    door_no: "",
    street: "",
    city: "",
    postal_code: "",
  });
  //console.log(customer);

  const hadnleInput = (e: any, field: String) => {
    const value = e.target.value;
    // setcustomer({...customer,[field]:value});
    if (field === "first_name") {
      setcustomer({ ...customer, first_name: value });
    }
  };

  const handleCreateCustomer = () => {
    // setcustomer({
    //   ...customer,
    //   id: Math.floor(Math.random() * 100),
    //   gender: "Male",
    // });

    // setData([...data, customer]);
    setData([...data, customer]);
    settoggleRegister({
      isToggled: false,
      customer: null,
    });
  };

  useEffect(() => {}, []);

  return (
    <div className={styles.overlay_model}>
      <div className={styles.register_container}>
        <div className={styles.customer_container}>
          <button
            onClick={() =>
              settoggleRegister({
                isToggled: true,
                customer: null,
              })
            }
          >
            ADD +{" "}
          </button>
          <input
            type="text"
            placeholder="search customer"
            onChange={(e) => setfilterQuery(e.target.value)}
          />
          {customerList.length > 0 ? (
            <div className={styles.customer_list}>
              {filterQuery === ""
                ? customerList.map((item: any) => (
                    <div
                      className={styles.customer}
                      onClick={() =>
                        settoggleRegister({
                          isToggled: true,
                          customer: item,
                        })
                      }
                    >
                      <span>{item.customer_name}</span>
                      {/* <span>{item.last_name}</span> */}
                    </div>
                  ))
                : customerList
                    .filter((item: any) =>
                      item.customer_name
                        .toLowerCase()
                        .includes(filterQuery.toLowerCase())
                    )
                    .map((item: any) => (
                      <div
                        className={styles.customer}
                        onClick={() =>
                          settoggleRegister({
                            isToggled: true,
                            customer: item,
                          })
                        }
                      >
                        <span>{item.first_name}</span>
                        <span>{item.last_name}</span>
                      </div>
                    ))}
            </div>
          ) : (
            <h3>No Customers</h3>
          )}
        </div>
        <button onClick={onClick}>close</button>
      </div>

      {toggleRegister.isToggled === true && (
        <div className={styles.register_customer}>
          {toggleRegister.customer === null ? "Add Customer" : "Edit Customer"}
          <div className={styles.register_header}>
            <ArrowBackIos onClick={() => settoggleRegister(false)} />
          </div>

          <div className={styles.form_ontainer}>
            {toggleRegister.customer !== null && (
              <span>
                Total payable: {" " + toggleRegister.customer.total_payable}
              </span>
            )}
            <input
              type="text"
              placeholder="Customer Code"
              value={customer.customer_code}
              //  onChange={(e) => hadnleInput(e, "last_name")}
              // onChange={(e) =>
              //  // setcustomer({ ...customer, customer_name: e.target.value })
              // }
            />
            <input
              type="text"
              placeholder="Customer Name"
              //  onChange={(e) => hadnleInput(e, "first_name")}
              onChange={(e) =>
                setcustomer({ ...customer, customer_name: e.target.value })
              }
              value={
                toggleRegister.customer !== null
                  ? toggleRegister.customer.customer_name
                  : null
              }
            />
            <input
              type="text"
              placeholder="Contact number"
              // onChange={(e) => hadnleInput(e, "contact")}
              onChange={(e) =>
                setcustomer({ ...customer, contact_no: e.target.value })
              }
              value={
                toggleRegister.customer !== null
                  ? toggleRegister.customer.contact_no
                  : null
              }
            />

            <input
              type="text"
              placeholder="Email"
              //  onChange={(e) => hadnleInput(e, "email")}
              onChange={(e) =>
                setcustomer({ ...customer, email: e.target.value })
              }
              value={
                toggleRegister.customer !== null
                  ? toggleRegister.customer.email
                  : null
              }
            />
            <input
              type="text"
              placeholder="Door Number"
              //  onChange={(e) => hadnleInput(e, "last_name")}
              onChange={(e) =>
                setcustomer({ ...customer, door_no: e.target.value })
              }
              value={
                toggleRegister.customer !== null
                  ? toggleRegister.customer.door_no
                  : null
              }
            />
            <input
              type="text"
              placeholder="Address Line 1"
              //  onChange={(e) => hadnleInput(e, "last_name")}
              onChange={(e) =>
                setcustomer({ ...customer, street: e.target.value })
              }
              value={
                toggleRegister.customer !== null
                  ? toggleRegister.customer.street
                  : null
              }
            />
            <input
              type="text"
              placeholder="City"
              //  onChange={(e) => hadnleInput(e, "last_name")}
              onChange={(e) =>
                setcustomer({ ...customer, city: e.target.value })
              }
              value={
                toggleRegister.customer !== null
                  ? toggleRegister.customer.city
                  : null
              }
            />
            <input
              type="text"
              placeholder="Postal Code "
              //  onChange={(e) => hadnleInput(e, "last_name")}
              onChange={(e) =>
                setcustomer({ ...customer, postal_code: e.target.value })
              }
              value={
                toggleRegister.customer !== null
                  ? toggleRegister.customer.postal_code
                  : null
              }
            />
            {toggleRegister.customer === null ? (
              <button
                onClick={handleCreateCustomer}
                disabled={
                  customer.customer_name === "" || customer.contact_no === ""
                    ? true
                    : false
                }
              >
                Create
              </button>
            ) : (
              <button onClick={() => {}}>Update</button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default RegisterCustomer;
